import React from 'react';
import { FaEdit } from '@react-icons/all-files/fa/FaEdit';
import { FiRefreshCw } from '@react-icons/all-files/fi/FiRefreshCw';
import { FiCheck } from '@react-icons/all-files/fi/FiCheck';
import { Button } from 'antd';
import TextArea from '../../../../components/forms/BuilderTextArea'
import DescriptionSuggestion from '../DescriptionSuggestion';
import './index.scss';

const ProfessionalSummaryStep = (props) => {
  const { params, onChange } = props;
  const onContinueClick = () => {
    props.onContinueClick && props.onContinueClick();
  };
  const onBackClick = () => {
    props.onBackClick && props.onBackClick();
  };
  const handleAddSuggestion = (suggestion) => {
    onChange('summary', suggestion);
  };
  return (
    <div className="step summary-step">
      <div className="step-inner-content">
        <div className="step-header">
          <h2>Professional summary</h2>
          <p>Include your professional title, years of experience, and your most impressive achievements. Each achievement should be measurable and expressed in numbers.</p>
        </div>
        <div className="summary-card">
          <div className="summary-input-wrapper">
            <TextArea
              className="summary-input"
              placeholder="Dynamic professional with a keen interest in fostering strong interpersonal connections and effective communication. Demonstrates readiness to learn and adapt in diverse environments, showcasing reliability and a commitment to punctuality. Eager to leverage advanced communication skills to contribute positively and grow within a forward-thinking organization."
              rows={2}
              value={params.summary || ''}
              onChange={e => onChange('summary', e)}
            />
            <DescriptionSuggestion
              flow="summary"
              selector="summary"
              resumeData={params}
              onAdd={handleAddSuggestion}
            />
          </div>
        </div>
      </div>
      <div className="step-footer">
        <button className="back-btn" onClick={onBackClick}>&larr; Back</button>
        <Button loading={props.formLoading} className="next-btn" onClick={onContinueClick}>Next <span className="arrow">&rarr;</span></Button>
      </div>
    </div>
  );
};

export default ProfessionalSummaryStep;
